<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md"></ion-back-button>
    </ion-buttons>

    <ion-title> {{ title }} </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="orderItemForm">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-item lines="none">
            <ion-label position="stacked"> Supplier </ion-label>
            <ionic-selectable
              [(ngModel)]="supplier"
              [ngModelOptions]="{standalone: true}"
              [items]="productSuppliers"
              itemValueField="id"
              itemTextField="name"
              [canSearch]="true"
            >
            </ionic-selectable>
          </ion-item>

          <ion-item lines="none">
            <ion-label position="stacked">Status</ion-label>
            <ion-select placeholder="Status" formControlName="orderStatusID">
              <ion-select-option [value]="1">Ordered</ion-select-option>
              <ion-select-option [value]="2">Dispatched</ion-select-option>
              <ion-select-option [value]="3">Received</ion-select-option>
              <ion-select-option [value]="4">Overdue</ion-select-option>
              <ion-select-option [value]="5">Cancelled</ion-select-option>
              <ion-select-option [value]="6">Failed</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>

        <ion-col>
          <ion-item lines="none">
            <ion-label position="stacked">Supplier Invoice #</ion-label>
            <ion-input
              type="text"
              name=""
              formControlName="supplierInvoiceNumber"
              class="sm-input-border"
            ></ion-input>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          
          <div class="ion-padding">
            <ion-label position="stacked">Expected Delivery</ion-label>
            <div
              class="ng-untouched ng-pristine ng-valid ion-untouched ion-pristine ion-valid sc-ion-input-md-h sc-ion-input-md-s md has-value hydrated"
            >
              <input
                [ngClass]="{'native-input': true, 'sc-ion-input-md': !isIOS, 'sc-ion-input-ios': isIOS}"
                [disabled]="stockOrderID != undefined"
                theme="light"
                placeholder="YY-MM-DD"
                formControlName="expectedDelivery"
                [owlDateTimeTrigger]="dt0"
                [owlDateTime]="dt0"
              />
            </div>
            <owl-date-time [pickerType]="'calendar'" #dt0></owl-date-time>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <ion-item>
            <ion-label position="stacked">Notes</ion-label>
            <ion-input
              type="text"
              name=""
              formControlName="notes"
              class="sm-input-border"
              clearInput
            ></ion-input>
          </ion-item>
        </ion-col>
      </ion-row>

      <div style="width: 90%; margin: auto">
        <p-table
          #table
          dataKey="id"
          [value]="stats"
          [loading]="isLoading"
          [responsive]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          responsiveLayout="stack"
          [breakpoint]="'960px'"
        >
          <ng-template pTemplate="header" let-columns>
            <tr *ngIf="stats.length !== 0">
              <th [pSortableColumn]="'name'">Name</th>
              <th [pSortableColumn]="'stock'">Stock</th>
              <th>Quantity</th>
              <th>Received</th>
              <th>Supplier Price</th>
              <th *ngIf="!stockOrderID"></th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-stat let-columns="columns">
            <tr>
              <td>
                <span class="p-column-title"><b>Name</b></span>
                <b>{{ stat.name}}</b>
              </td>
              <td>
                <span class="p-column-title"><b>Stock</b></span>
                <span>{{ stat.stock }}</span>
              </td>
              <td>
                <span class="p-column-title"><b>Quantity</b></span>
                <ion-input
                  class="sm-input-border"
                  style="max-width: 150px"
                  type="number"
                  [(ngModel)]="stat.quantity"
                  [ngModelOptions]="{standalone: true}"
                  clearInput
                ></ion-input>
              </td>
              <td>
                <span class="p-column-title"><b>Received</b></span>
                <ion-input
                  class="sm-input-border"
                  style="max-width: 150px"
                  type="number"
                  [(ngModel)]="stat.received"
                  [ngModelOptions]="{standalone: true}"
                  clearInput
                ></ion-input>
              </td>
              <td>
                <span class="p-column-title"><b>Supplier Price</b></span>
                <ion-input
                  class="sm-input-border"
                  style="max-width: 150px"
                  type="number"
                  [(ngModel)]="stat.supplierPrice"
                  [ngModelOptions]="{standalone: true}"
                  clearInput
                ></ion-input>
              </td>
              <td *ngIf="!stockOrderID">
                <span class="p-column-title"></span>
                <ion-button
                  fill="outline"
                  expand="block"
                  color="danger"
                  (click)="remove(stat)"
                  >Delete</ion-button
                >
              </td>
            </tr>
          </ng-template>
        </p-table>
        <ion-button
          class="ion-margin"
          *ngIf="!stockOrderID"
          style="height: 40px; width: 200px; margin-left: 1%"
          fill="outline"
          expand="block"
          color="primary"
          (click)="showProductList()"
        >
          Add Product(s)
        </ion-button>
      </div>
    </ion-grid>
  </form>
</ion-content>

<ion-footer style="position: absolute; bottom: 0">
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button expand="block" (click)="orderSave()">
            Complete
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
